var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentsSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "documents_selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-icons-/-documents-(green)",
    transform: "translate(-2.000000, -1.000000)",
    fill: "#37DC58",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.00002342,7 L8.00305312,1 L18.9980231,1 C19.5500231,1 20.0000234,1.455002 20.0000234,1.992002 L20.0000234,20.007962 C19.9998231,20.271162 19.8950231,20.523462 19.7088231,20.709462 C19.5226231,20.895562 19.2702231,20.999962 19.0070231,20.999962 L2.99304312,20.999962 C2.86172312,20.999062 2.73187312,20.972262 2.61089312,20.921162 C2.48991812,20.870062 2.38019312,20.795662 2.28798412,20.702162 C2.19577512,20.608662 2.12288712,20.497862 2.07348312,20.376262 C2.02407812,20.254562 1.99912512,20.124362 2.00002342,19.992962 L2.00002342,7 Z M9.00004312,2.500002 L3.50004312,8.000002 L9.00004312,8.000002 L9.00004312,2.500002 Z",
    id: "documents_selected"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsSelected);
export default __webpack_public_path__ + "static/media/documents_selected.8aec4bccf5b6cab8878b76914a25732a.svg";
export { ForwardRef as ReactComponent };